import { version } from '../../package.json';

export const environment = {
  production: true,
  apiUrl: 'https://prod-ng.sharelock.pro',
  version: version,
};
